<div class="upload-progress-cont">
  <div class="upload-progress" [style.width]="progress + '%'">
  </div>
</div>
